<script setup>
import ForminatorForm from '@/components/Forminator/ForminatorForm.vue';
import LegalPageHero from '@/components/heros/LegalPageHero.vue';
import { onMounted } from 'vue';
import { usePageStore } from '@/stores/pageStore';
import { useMenuStore } from '@/stores/menuStore';

onMounted(() => {
  const store = usePageStore();
  store.emptyPageContent();

  const menuStore = useMenuStore();
  menuStore.fetchMenus();
});
</script>

<template>
  <div class="contact-page">
    <LegalPageHero
      title="Contactez-nous">
    </LegalPageHero>
    <ForminatorForm :id="123" class="contact-form"/>
  </div>
</template>

<style scoped>
.contact-page {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  padding: 0 25px;
}
h1 {
  margin-bottom: 1rem;
}
</style>
